import { inject, Injectable, Provider, signal } from '@angular/core';
import { Router } from '@angular/router';
import { APPLICATION_CONTEXT, ApplicationContext, NavMenuItem } from '@processpuzzle/base-widget';
import { NavigationItem, navigationItems } from './navigation-routes';

/**
 * This application's answer to base-widget's `APPLICATION_CONTEXT`: its name, its logo and the
 * titled routes, for `app-title` and `nav-menu` to read without props.
 *
 * base-app's shell provides the context from the `AppDefinition` it renders; this application is
 * hand-built and has no definition, so it provides its own. The routes are read through
 * {@link navigationItems}, the same source the sidenav renders, so the handset menu and the sidenav
 * cannot offer different navigation.
 */
@Injectable()
export class BizApplicationContext implements ApplicationContext {
  private readonly router = inject(Router);

  readonly name = signal('ProcessPuzzle').asReadonly();
  readonly logoUrl = signal<string | undefined>('assets/processpuzzle-logo-with-title.jpg').asReadonly();
  readonly navItems = signal(navigationItems(this.router).map(toNavMenuItem)).asReadonly();
}

export function provideBizApplicationContext(): Provider[] {
  return [{ provide: APPLICATION_CONTEXT, useClass: BizApplicationContext }];
}

function toNavMenuItem(item: NavigationItem): NavMenuItem {
  return {
    id: item.link,
    label: item.menuTitle,
    translocoId: `navigation.${item.menuTitle}`,
    ...(item.icon ? { icon: item.icon } : {}),
    routePath: item.link,
  };
}
